import type { DefaultNamespace } from 'i18next'
import type { FC, ReactNode } from 'react'
import { ButtonBrandLegacy } from '@/components/ui/button-brand-legacy'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { XCloseIcon } from '@/components/ui/icons'
import { Modal } from '@/components/ui/modal'
import {
	ModalBody,
	ModalFooter,
	ModalHeader
} from '@/components/ui/modal-atoms'
import { Separator } from '@/components/ui/separator'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/translations/i18n'

interface ConfirmActionModalProps {
	isLoading: boolean
	onClose: () => void
	onConfirm: () => void
	headerTitle: string | DefaultNamespace
	title: string | DefaultNamespace
	paragraph: ReactNode
}

export const ConfirmActionModal: FC<ConfirmActionModalProps> = ({
	isLoading,
	onClose,
	onConfirm,
	headerTitle,
	title,
	paragraph
}) => {
	const { t } = useTranslation()
	return (
		<Modal closeIconOffset='sm' onOverlayClick={onClose} width={480}>
			<ModalHeader>
				<ButtonLegacy
					onClick={onClose}
					shape='square'
					size='sm'
					type='button'
					variant='tertiary'
				>
					<XCloseIcon size={20} />
				</ButtonLegacy>
				<h3 className='font-semibold'>{headerTitle}</h3>
			</ModalHeader>

			<Separator orientation='horizontal' />

			<ModalBody className='text-neutral-900'>
				<div className='flex flex-col gap-2'>
					<h4 className='font-medium text-xl'>{title}</h4>
					<p className='mt-2 text-sm'>{paragraph}</p>
				</div>
			</ModalBody>

			<ModalFooter>
				<ButtonLegacy
					disabled={isLoading}
					onClick={onClose}
					type='button'
					variant='tertiary'
				>
					{t('common:cancel')}
				</ButtonLegacy>
				<ButtonBrandLegacy disabled={isLoading} onClick={onConfirm}>
					{t('common:confirm')}
					{isLoading && <Spinner size={16} />}
				</ButtonBrandLegacy>
			</ModalFooter>
		</Modal>
	)
}

ConfirmActionModal.displayName = 'ConfirmActionModal'
